import { Box, Checkbox, FormControlLabel, Tooltip, Typography } from "@mui/material";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import IconButton from "components/@extended/IconButton";
import { useTranslation } from "utils/locales/utilityFunctions";

type RegenerationAgreementFieldProps = {
  checked: boolean;
  inputDisabled: boolean;
  agreementRequired?: boolean;
  loading?: boolean;
  onChange: (change: { value: boolean; key: string; parent: string }) => void;
  onUpload: (state: boolean, categories?: string[]) => void;
};

const RegenerationAgreementField = ({
  checked,
  inputDisabled,
  agreementRequired = false,
  loading = false,
  onChange,
  onUpload,
}: RegenerationAgreementFieldProps) => {
  const { translate } = useTranslation();
  // Protected-forest checkbox rules must not disable attaching the agreement.
  const uploadDisabled = inputDisabled || loading;

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box>
        <Typography color="secondary">
          {translate("biomass-project-form-regeneration-agreement-title")}
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={(_, value) =>
                onChange({ value, key: "regeneration", parent: "standAndActivity" })
              }
              icon={
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    bgcolor: "white",
                    border: inputDisabled ? "1px solid #bfbfbf" : "1px solid #7a7a7a",
                  }}
                />
              }
              disabled={agreementRequired}
            />
          }
          label={translate("biomass-project-form-regeneration-agreement")}
          disabled={inputDisabled}
          sx={{ ml: 0, mb: -1 }}
        />
      </Box>
      {checked && (
        <Box sx={{ mt: 1, ml: 2 }}>
          <Tooltip title={translate("biomass-project-form-upload-doc-tooltip")}>
            <span>
              <IconButton
                aria-label={translate("biomass-project-form-upload-doc-tooltip")}
                variant="light"
                color="secondary"
                sx={{ bgcolor: "secondary.light" }}
                onClick={() => onUpload(true, ["screening", "standAndActivity", "regeneration"])}
                disabled={uploadDisabled}
              >
                <FileUploadRoundedIcon fontSize="small" color={uploadDisabled ? "disabled" : "primary"} />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default RegenerationAgreementField;
